export default __webpack_public_path__ + "static/media/sails.486e6b02.svg";